import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './search.loaders';
import { converters } from './search.converters';

export const searchKeys = queryKeyFactory('search');

export const useSearchResults = (query: string) => {
  return useQuery({
    queryKey: searchKeys.detail(query),
    queryFn: () => loaders.getSearchResults({ query }),
    select: converters.getSearchResults,
    enabled: !!query,
  });
};
